import { cx } from '@emotion/css';

import { ListProps } from './list-unordered.models';
import { Icon } from '../icon';
import { useStyles } from './list-unordered.styles';

export const ListUnordered = ({ items, listStyles, itemStyles, listGap, testId, ...props }: ListProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ul
      {...props}
      className={cx(classes.root, listGap, listStyles)}
      data-testid={testId}
    >
      {items.map(({ id, item, icon, iconSize }) => (
        <li
          key={id}
          className={itemStyles}
        >
          {icon && (
            <Icon
              type={icon}
              size={iconSize}
            />
          )}
          {item}
        </li>
      ))}
    </ul>
  );
};
